import ElectronicRelays from "../classes/ElectronicRelay"
import { Position } from 'reactflow';

export const electronicRelays = [
  new ElectronicRelays({alias:"ups", svgSrc: "/symbol-assets/UPS.svg", label: "UPS / Regulador de voltaje"}),
  new ElectronicRelays({alias:"variador-de-frecuencia", svgSrc: "/symbol-assets/VariadorDeFrecuencias.svg", label: "Variador de frecuencia"}),
  new ElectronicRelays({alias:"rectificador", svgSrc: "/symbol-assets/Rectificador.svg", label: "Rectificador"}),
  new ElectronicRelays({alias:"inversor", svgSrc: "/symbol-assets/Inversor.svg", label: "Inversor"}),
  new ElectronicRelays({alias:"arrancador-suave", svgSrc: "/symbol-assets/ArrancadorSuave.svg", label: "Arrancador"}),
  
];
